export default __webpack_public_path__ + "static/media/Add_new_app.86fb9c82.svg";